import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { JssNodeNumber } from '../../model/jss-tree-number';
import { FormArray } from '@angular/forms/src/model';

@Component({
   selector: 'app-mat-number',
   templateUrl: './number.component.html',
   styleUrls: ['./number.component.scss']
})
export class NumberComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title = '';
   public _visible = true;
   public _formControl: FormControl = null;
   public _formParent: FormGroup | FormArray = null;

   @Input() jssTreeLeaf: JssNodeNumber;
   @Input() readonly = false;

   constructor() { }

   ngOnInit() {
   }

   ngOnChanges() {
      if (this.jssTreeLeaf && !this.jssTreeLeaf.valuePassThrough) {
         this._nodeName = this.jssTreeLeaf.nodeName;
         this._nodeType = this.jssTreeLeaf.nodeType;
         this._formControl = this.jssTreeLeaf.getFormControl();
         this._formParent = this.jssTreeLeaf.getFormControlParent();

         // title
         if (this.jssTreeLeaf.showTitle) {
            this._title = this.jssTreeLeaf.hasTitle() ? this.jssTreeLeaf.title : this._nodeName;
         }

         // watch changes
         this._formControl.valueChanges.subscribe( val => {
            this.jssTreeLeaf.valueChanged(val);
         });
      }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/number/number.component.ts